import {
  Card,
  CardContent,
  CardHeader,
  Alert,
  Grid,
  AlertTitle,
  Chip,
  Typography
} from '@mui/material';
import ReactHtmlParser from 'react-html-parser';

export default function PolicyClausesPreview({ pdfPreview }) {
  return (
    <Card
      sx={{
        border: '1px dashed grey',
        mt: 2
      }}
    >
      {pdfPreview?.policyClauseJSON.length > 0 ? (
        <CardContent>
          <CardHeader title={'Policy Clauses'} />
          {pdfPreview?.policyClauseJSON?.map((formGroupClauseData) => {
            return (
              <Grid item xs={12} mt={1}>
                <Alert variant="outlined" severity="warning">
                  <AlertTitle>
                    {formGroupClauseData.companyTitle
                      ? formGroupClauseData.companyTitle
                      : formGroupClauseData.title}
                  </AlertTitle>
                  {ReactHtmlParser(
                    formGroupClauseData.companyDetailDescription
                      ? formGroupClauseData.companyDetailDescription
                      : formGroupClauseData.detailDescription
                  )}
                  {formGroupClauseData.type === 'coverage' ? (
                    <>
                      <Chip
                        label={`Sum Insured : ${formGroupClauseData.sumInsured}`}
                        color="error"
                        variant="outlined"
                      />{' '}
                      &nbsp;
                    </>
                  ) : null}
                  {formGroupClauseData.insuranceClauseInputs?.map(
                    (formGroupClauseInput) => {
                      return (
                        <Typography variant="subtitle1" gutterBottom>
                          {formGroupClauseInput.label} :{' '}
                          {formGroupClauseInput.value
                            ? formGroupClauseInput.value
                            : 'N/A'}
                        </Typography>
                      );
                    }
                  )}
                </Alert>
              </Grid>
            );
          })}
        </CardContent>
      ) : (
        <CardContent>
          <Alert severity="warning">No Clause(s) Found.</Alert>
        </CardContent>
      )}
    </Card>
  );
}
